import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export default styled.section`
  padding-top: 32px;
  background-color: #fff;
  padding-bottom: 8px;

  @media (min-width: ${getBreakpoint('md')}px) {
    padding-top: 96px;
    padding-bottom: 48px;
  }
`
